import { Controller } from "stimulus";
import { format, startOfWeek, startOfMonth } from "date-fns";

export default class extends Controller {
  static targets = ["display", "popover", "customInputs", "startDate", "endDate"];

  connect() {
    this.form = this.element; // form_with makes the controller root the <form>
    this.presetInput = this.form.querySelector('input[name="preset"]');
    this.hiddenStart = this.form.querySelector('input[name="start_date"]');
    this.hiddenEnd = this.form.querySelector('input[name="end_date"]');

    const params = new URLSearchParams(window.location.search);

    this.selectedRange = params.get("preset") || "last_30_days";
    this.start = params.get("start_date") || new Date();
    this.end = params.get("end_date") || new Date();
    this.updateDisplay();
  }

  togglePopover() {
    this.popoverTarget.classList.toggle("d-none");
  }

  selectRange(event) {
    const range = event.currentTarget.dataset.range;
    this.selectedRange = range;
    const today = new Date();

    switch (range) {
      case "last_30_days":
        break;
      case "today":
        this.start = today;
        this.end = today;
        break;
      case "yesterday":
        this.start = new Date(today);
        this.start.setDate(this.start.getDate() - 1);
        this.end = this.start;
        break;
      case "this_week":
        this.start = startOfWeek(today, { weekStartsOn: 1 });
        this.end = today;
        break;
      case "this_month":
        this.start = startOfMonth(today);
        this.end = today;
        break;
      case "custom":
        this.showCustomInputs();
        return;
    }

    this.updateDisplay();
    this.submitForm();
    this.closePopover();
  }

  showCustomInputs() {
    this.customInputsTarget.classList.remove("d-none");
  }

  applyCustom() {
    const startDate = new Date(this.startDateTarget.value);
    const endDate = new Date(this.endDateTarget.value);
    if (startDate && endDate) {
      this.start = startDate;
      this.end = endDate;
      this.updateDisplay("custom");
      this.submitForm();
      this.closePopover();
    }
  }

  updateDisplay(forceRange = null) {
    const range = forceRange || this.selectedRange;
    let text = "";

    switch (range) {
      case "today":
        text = `Today: ${format(this.start, "do MMM yyyy")}`;
        break;
      case "yesterday":
        text = `Yesterday: ${format(this.start, "do MMM yyyy")}`;
        break;
      case "this_week":
        text = `This week: ${format(this.start, "do MMM")} - ${format(this.end, "do MMM yyyy")}`;
        break;
      case "this_month":
        text = `This month: ${format(this.start, "do MMM")} - ${format(this.end, "do MMM yyyy")}`;
        break;
      case "custom":
        text = `Custom: ${format(this.start, "do MMM")} - ${format(this.end, "do MMM yyyy")}`;
        break;
      case "last_30_days":
        text = 'Last 30 days'
        break;
    }

    this.displayTarget.textContent = text;

    // set hidden inputs for form submission
    this.presetInput.value = range;
    this.hiddenStart.value = format(this.start, "yyyy-MM-dd");
    this.hiddenEnd.value = format(this.end, "yyyy-MM-dd");
  }

  submitForm() {
    this.form.submit();
  }

  closePopover() {
    this.popoverTarget.classList.add("d-none");
    this.customInputsTarget.classList.add("d-none");
  }
}